<template>
  <slot :isChameleon="isChameleon"></slot>
</template>

<script>
import { onMounted, onUnmounted, ref } from 'vue'
const EDGE_OFFSET = 200

export default {
  props: ['enabled'],
  setup(props) {
    const cover = ref(null)
    const mounted = ref(false)
    const isChameleon = ref(props.enabled)

    function scrollWatcher(cover) {
      let rect = cover.getBoundingClientRect()

      if (rect.bottom < EDGE_OFFSET) {
        isChameleon.value = false
      } else {
        isChameleon.value = true
      }
    }

    function handleScroll() {
      if (!props.enabled) {
        return
      }

      scrollWatcher(cover.value)
    }

    onMounted(() => {
      if (!props.enabled) {
        return
      }

      mounted.value = true
      setTimeout(() => {
        cover.value = document.getElementById('CoverSection')
        if (mounted.value) {
          handleScroll()
          window.addEventListener('scroll', handleScroll)
        }
      }, 0)
    })

    onUnmounted(() => {
      if (!props.enabled) {
        return
      }
      mounted.value = false
      window.removeEventListener('scroll', handleScroll)
    })

    return {
      cover,
      isChameleon
    }
  }
}
</script>
